export default __webpack_public_path__ + "static/media/money.9a82b769.svg";